import { defineComponent as M, inject as b, ref as w, computed as s, h as n } from "vue";
import y from "./ghl-ui.es1539.js";
import V from "./ghl-ui.es1540.js";
import { dataTableInjectionKey as x } from "./ghl-ui.es949.js";
import S from "./ghl-ui.es860.js";
import T from "./ghl-ui.es200.js";
import O from "./ghl-ui.es867.js";
import j from "./ghl-ui.es1408.js";
function k(r, i, o) {
  const e = Object.assign({}, r);
  return e[i] = o, e;
}
const q = M({
  name: "DataTableFilterButton",
  props: {
    column: {
      type: Object,
      required: !0
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  setup(r) {
    const { mergedComponentPropsRef: i } = S(), {
      mergedThemeRef: o,
      mergedClsPrefixRef: e,
      mergedFilterStateRef: a,
      filterMenuCssVarsRef: m,
      paginationBehaviorOnFilterRef: h,
      doUpdatePage: p,
      doUpdateFilters: v
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = b(x), u = w(!1), d = a, f = s(() => r.column.filterMultiple !== !1), c = s(() => {
      const t = d.value[r.column.key];
      if (t === void 0) {
        const { value: l } = f;
        return l ? [] : null;
      }
      return t;
    }), g = s(() => {
      const { value: t } = c;
      return Array.isArray(t) ? t.length > 0 : t !== null;
    }), F = s(() => {
      var t, l;
      return ((l = (t = i == null ? void 0 : i.value) === null || t === void 0 ? void 0 : t.DataTable) === null || l === void 0 ? void 0 : l.renderFilter) || r.column.renderFilter;
    });
    function C(t) {
      const l = k(d.value, r.column.key, t);
      v(l, r.column), h.value === "first" && p(1);
    }
    function P() {
      u.value = !1;
    }
    function R() {
      u.value = !1;
    }
    return {
      mergedTheme: o,
      mergedClsPrefix: e,
      active: g,
      showPopover: u,
      mergedRenderFilter: F,
      filterMultiple: f,
      mergedFilterValue: c,
      filterMenuCssVars: m,
      handleFilterChange: C,
      handleFilterMenuConfirm: R,
      handleFilterMenuCancel: P
    };
  },
  render() {
    const { mergedTheme: r, mergedClsPrefix: i, handleFilterMenuCancel: o } = this;
    return n(T, { show: this.showPopover, onUpdateShow: (e) => this.showPopover = e, trigger: "click", theme: r.peers.Popover, themeOverrides: r.peerOverrides.Popover, placement: "bottom", style: { padding: 0 } }, {
      trigger: () => {
        const { mergedRenderFilter: e } = this;
        if (e)
          return n(y, { "data-data-table-filter": !0, render: e, active: this.active, show: this.showPopover });
        const { renderFilterIcon: a } = this.column;
        return n("div", { "data-data-table-filter": !0, class: [
          `${i}-data-table-filter`,
          {
            [`${i}-data-table-filter--active`]: this.active,
            [`${i}-data-table-filter--show`]: this.showPopover
          }
        ] }, a ? a({
          active: this.active,
          show: this.showPopover
        }) : n(O, { clsPrefix: i }, { default: () => n(j, null) }));
      },
      default: () => {
        const { renderFilterMenu: e } = this.column;
        return e ? e({ hide: o }) : n(V, { style: this.filterMenuCssVars, radioGroupName: String(this.column.key), multiple: this.filterMultiple, value: this.mergedFilterValue, options: this.options, column: this.column, onChange: this.handleFilterChange, onClear: this.handleFilterMenuCancel, onConfirm: this.handleFilterMenuConfirm });
      }
    });
  }
});
export {
  q as default
};
